import { useCallback } from 'react';
import { RoutesMaps } from '../../../content-blocks/common/routes-map-model';
import { useOrgInfo } from '../use-org-info/use-org-info';
import { HideablePageId } from './hideable-pages';

export const isPageHidden = (hiddenPages: string[] | undefined, pageId?: string): boolean =>
  pageId !== undefined && hiddenPages !== undefined && hiddenPages.length > 0 && hiddenPages.includes(pageId);

export const withHiddenPages = (routesMap: RoutesMaps, hiddenPages: string[] | undefined): RoutesMaps =>
  !hiddenPages || hiddenPages.length === 0
    ? routesMap
    : {
        ...routesMap,
        items: routesMap.items.map((item) => (isPageHidden(hiddenPages, item.id) ? { ...item, hidden: true } : item)),
      };

export const useIsPageHidden = () => {
  const hiddenPages = useOrgInfo()?.hiddenPages;

  return useCallback((pageId: HideablePageId) => isPageHidden(hiddenPages, pageId), [hiddenPages]);
};
